import LiveClock from 'components/common/LiveClock'
import AccountForm from 'components/type/AddType'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CreateAccount = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> {t("common.back")}
                    </button>
                    <h2 className={`main_heading`}>{t("clients.createAccounts")}</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            <AccountForm />
        </div>
    )
}

export default CreateAccount